// Thumbnail image quality fix
document.addEventListener('DOMContentLoaded', function() {
  var thumbs = document.querySelectorAll('.slideshow-controls__thumbnail img');
  thumbs.forEach(function(img) {
    var src = img.getAttribute('src');
    if (src) {
      img.setAttribute('src', src.replace('width=144', 'width=400'));
    }
    var srcset = img.getAttribute('srcset');
    if (srcset) {
      img.setAttribute('srcset', srcset.replace('width=144', 'width=400'));
    }
  });
});



document.addEventListener('click', function(e) {

  const nextBtn = e.target.closest('.snz-gallery-next');
  const prevBtn = e.target.closest('.snz-gallery-prev');

  if (!nextBtn && !prevBtn) return;


  let section = (nextBtn || prevBtn).closest(
    'featured-product-information, product-information, .shopify-section, [class*="product"]'
  );

  
  while (section && !section.querySelector('slideshow-component')) {
    section = section.parentElement;
  }

  if (!section) return;

  const slideshow = section.querySelector('slideshow-component');
  if (!slideshow) return;

  const trySlide = () => {
    const instance = slideshow.component || slideshow;

    if (nextBtn) {
      if (instance?.next) return instance.next();
      if (instance?.nextSlide) return instance.nextSlide();
      if (instance?.goNext) return instance.goNext();
    }

    if (prevBtn) {
      if (instance?.prev) return instance.prev();
      if (instance?.prevSlide) return instance.prevSlide();
      if (instance?.goPrev) return instance.goPrev();
    }

    const next = section.querySelector('.slideshow-control--next');
    const prev = section.querySelector('.slideshow-control--previous');

    if (nextBtn && next) next.click();
    if (prevBtn && prev) prev.click();
  };

  requestAnimationFrame(() => {
    setTimeout(trySlide, 50);
  });

});